import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { TextField, InputAdornment } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import { get } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import { getCivilJudgement } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/utils';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';

export interface CivilJudgementRecapVehicleProps {
  intl: IntlShape;
  listings?: Listings;
  isManager?: boolean;
  dahirAmount?: any;
  responsabilityShareValue?: string;
  expertises?: any;
  isAppeal?: boolean;
  isRejected?: boolean;
  judgementOnMeritsRequest: any;
  civj: any;
  civjvm?: any;
  isContested?: boolean;
  handleOpenContestation: Function;
  handleExpertiseChange: Function;
  civilJudgementType: any;
  handleCivJvmChange: Function;
  judgementOnMerits: any;
  sagisVictimInfo: any;
  judgement: any;
  setJudgement: Function;
  expertiseType?: any;
  civilJudgementUpdateExpertise?: any;
  setCivilJudgementUpdateExpertise?: Function;
  setJudgementOnMeritsRequest?: Function;
  vehicle?: any;
  expertiseJudgementAddDocumentId?: number;
  mode?: string;
}
const Picker = {
  ACCOUNTING: ({ ...props }) => {
    return (
      <>
        {((props.isContested && props.isManager) ||
          (!props.isRejected && !props.isManager)) && (
          <TextField
            label={translate(messages.damageAmountFieldTitle, props)}
            value={props.civj?.evaluationAmount}
            inputProps={{
              readOnly: true,
            }}
            className="calculated-amount"
          />
        )}

        {((!props.isContested && props.isManager) ||
          (props.isRejected && !props.isManager)) && (
          <TextField
            label={translate(messages.damageAmountFieldTitle, props)}
            value={
              /* istanbul ignore next */
              props.expertises && get(props.currentCivj, 'evaluationAmount', '')
            }
            name="evaluationAmount"
            onChange={
              props.handleExpertiseChange &&
              props.handleExpertiseChange(
                get(
                  props.civj,
                  'id',
                  `${props.vehicle?.id}-${props.expertiseJudgementAddDocumentId}`,
                ),
                0,
                INCIDENT_TYPE.VEHICLE,
                get(props, 'vehicle', props.civjvm?.vehicle),
              )
            }
            type="number"
            className="calculated-amount"
          />
        )}
      </>
    );
  },
  MECHANICAL: ({ ...props }) => (
    <>
      {((props.isJudgementOnMeritsContested && props.isManager) ||
        (!props.isManager && !props.isRejected)) && (
        <>
          <TextField
            id="damage_amount_field"
            label={translate(messages.damageAmountFieldTitle, props)}
            value={props.civj?.damageAmount}
            inputProps={{
              readOnly: true,
            }}
            className="calculated-amount"
          />
        </>
      )}
      {((!props.isJudgementOnMeritsContested && props.isManager) ||
        (props.isRejected && !props.isManager)) && (
        <TextField
          id="damage_amount_field"
          label={translate(messages.damageAmountFieldTitle, props)}
          value={
            /* istanbul ignore next */
            props.expertises && get(props.currentCivj, 'damageAmount', '')
          }
          onChange={
            props.handleExpertiseChange &&
            props.handleExpertiseChange(
              get(
                props.civj,
                'id',
                `${props.vehicle?.id}-${props.expertiseJudgementAddDocumentId}`,
              ),
              0,
              INCIDENT_TYPE.VEHICLE,
              get(props, 'vehicle', props.civjvm?.vehicle),
            )
          }
          name="damageAmount"
          className="calculated-amount"
        />
      )}
    </>
  ),
} as any;
const CivilJudgementRecapVehicle: React.FC<CivilJudgementRecapVehicleProps> = ({
  ...props
}): JSX.Element => {
  const Component = Picker[props.civilJudgementType];
  const currentCivj = getCivilJudgement(
    props.expertises || [],
    props.civj,
    props.vehicle,
    INCIDENT_TYPE.VEHICLE,
  );

  return (
    <div style={{ paddingTop: '10px' }}>
      {props.civilJudgementType && (
        <Component {...props} currentCivj={currentCivj} />
      )}
      {!props.isAppeal && (
        <div className="text-field-amount">
          {((props.isContested && props.isManager) ||
            (!props.isManager && !props.isRejected)) && (
            <TextField
              className="calculated-amount"
              label={translate(messages.provisionalExecutionFieldTitle, props)}
              value={props.civj?.provisionalExecution}
              inputProps={{
                readOnly: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {translate(
                      {
                        ...messages.responsibiltySharePercentage,
                      },
                      props,
                    )}
                  </InputAdornment>
                ),
              }}
            />
          )}
          {!props.isAppeal &&
            ((!props.isContested && props.isManager) ||
              (props.isRejected && !props.isManager)) && (
              <TextField
                className="calculated-amount"
                label={translate(
                  messages.provisionalExecutionFieldTitle,
                  props,
                )}
                value={
                  props.expertises &&
                  get(currentCivj, 'provisionalExecution', '')
                }
                onChange={
                  props.handleExpertiseChange &&
                  props.handleExpertiseChange(
                    get(
                      props.civj,
                      'id',
                      `${props.vehicle?.id}-${props.expertiseJudgementAddDocumentId}`,
                    ),
                    1,
                    INCIDENT_TYPE.VEHICLE,
                    get(props, 'vehicle', props.civjvm?.vehicle),
                  )
                }
                name="provisionalExecution"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        {
                          ...messages.responsibiltySharePercentage,
                        },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            )}
        </div>
      )}
    </div>
  );
};

export default injectIntl(CivilJudgementRecapVehicle);
